import { ajax } from '../ajax'


//、 授课-课中讨论列表
export const reqSKDiscussList = (paramets) => ajax(`/jxclassroom/jxClassroomTalk/getKTTalkList`, paramets)

//、 教学预习任务-通过id查询预习详情
export const reqSKDiscussDetails = (paramets) => ajax(`/jxclassroom/jxClassroomTalk/detailsToTalk`, paramets)

//、 授课-课中讨论添加
export const reqSKDiscussAdd = (paramets) => ajax(`/jxclassroom/jxClassroomTalk/add`, paramets, 'post')

//、 授课-课中讨论结束
export const reqSKDiscussOver = (paramets) => ajax(`/jxclassroom/jxClassroomTalk/overById`, paramets,)

//、 授课-课中讨论结果
export const reqSKDiscussRes = (paramets) => ajax(`/jxclassroom/jxClassroomTalk/resultsToTalk`, paramets)

//、 授课-课中讨论结果--词云
export const reqSKDiscussWord = (paramets) => ajax(`/jxclassroom/jxClassroomTalk/getWordCloud`, paramets)

//、 授课-课中讨论结果点赞
export const reqSKDiscussPraise = (paramets) => ajax(`/jxtalk/jxTalkPraise/add`, paramets, 'post')
